import { render, staticRenderFns } from "./CbsOrderTimeline.vue?vue&type=template&id=3b28ab85"
import script from "./CbsOrderTimeline.vue?vue&type=script&lang=js"
export * from "./CbsOrderTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports